import React, { useEffect, useState, useRef } from 'react';
import { PlusIcon, SendIcon, MicIcon } from 'lucide-react';
interface ChatInputProps {
  onSendMessage: (message: string) => void;
  placeholder?: string;
  isVoiceMode?: boolean;
  onToggleVoiceMode?: () => void;
}
export const ChatInput = ({
  onSendMessage,
  placeholder = 'Ask Blue Partner...',
  isVoiceMode = false,
  onToggleVoiceMode
}: ChatInputProps) => {
  const [message, setMessage] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const autoResizeTextarea = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${Math.min(textarea.scrollHeight, 200)}px`;
    }
  };
  useEffect(() => {
    setIsButtonDisabled(message.trim().length === 0);
  }, [message]);
  useEffect(() => {
    autoResizeTextarea();
  }, [message]);
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!isButtonDisabled) {
        sendMessage();
      }
    }
  };
  const sendMessage = () => {
    if (message.trim()) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };
  return <div className="w-full max-w-[1000px] mx-auto flex items-center gap-4 h-16" data-id="element-59">
      <div className="flex-grow bg-[#151A22]/50 border border-white/5 rounded-2xl px-5 flex items-center h-full" data-id="element-60">
        <div className="flex items-center gap-4 w-full" data-id="element-61">
          <button className="text-[#888888] hover:text-[#e0e0e0] transition-colors" title="Attach file" data-id="element-62">
            <PlusIcon size={22} data-id="element-63" />
          </button>
          <textarea ref={textareaRef} className="flex-grow bg-transparent focus:outline-none placeholder:text-[var(--placeholder)] text-lg py-2 resize-none h-10 overflow-hidden" placeholder={placeholder} value={message} onChange={e => setMessage(e.target.value)} onKeyDown={handleKeyDown} rows={1} data-id="element-64" />
          <button className={`rounded-full w-12 h-12 flex items-center justify-center transition-all ${!isButtonDisabled ? 'bg-[#4a90e2] text-white hover:bg-[#3a7bc2]' : 'bg-white/5 text-[#888888]'}`} disabled={isButtonDisabled} onClick={sendMessage} data-id="element-65">
            <SendIcon size={20} className={!isButtonDisabled ? 'text-white' : 'text-[#666666]'} data-id="element-66" />
          </button>
        </div>
      </div>

      <button onClick={onToggleVoiceMode} className={`rounded-full w-14 h-14 flex items-center justify-center transition-all flex-shrink-0 border ${isVoiceMode ? 'bg-[#4a90e2] border-[#4a90e2] shadow-lg shadow-[#4a90e2]/20' : 'bg-[#151A22] border-white/5 hover:bg-white/5'}`} data-id="element-67">
        <MicIcon size={22} className={isVoiceMode ? 'text-white' : 'text-[#e0e0e0]'} data-id="element-68" />
      </button>
    </div>;
};